import { QuestionBase } from './question-base';

/*
Sample:

new TextareaQuestion({
  key: 'about',
  label: 'nouns.about',
  order: 5
}),

*/
export class LinkQuestion extends QuestionBase<string> {
  controlType = 'link';

  constructor(options: {} = {}) {
    super({ ...options, designSystem: true });
  }

  copy = () => {
    /* eslint-disable */
    const el = document.createElement('textarea');
    el.value = this.value;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  };
}
